import React, { useState, useContext } from "react";
import { PreferredLanguageContext } from "../../lib/main-context";
import { HELP_PAGE } from "../../constants/HelpPageTranslation";

import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import helpSchema from "./validations/helpSchema";

import Sallie from "../UIComponents/Sallie";
import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";

import { postHelp } from "../../api/helpReq";

const HelpPage = () => {
  const { language } = useContext(PreferredLanguageContext);
  const t = HELP_PAGE[language];

  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitted, isSubmitSuccessful },
  } = useForm({
    resolver: yupResolver(helpSchema)
  });

  const onSubmit = async (data) => {
    try {
      // await postHelp(data);
      await new Promise((r) => setTimeout(r, 1000));
      console.log(data);
    } catch (err) {
      console.error("Help Page onSubmit Error:", err)
    }
  }

  let sallieText = t.default;
  if (isSubmitSuccessful) {
    sallieText = t.submitted;
  } else if (isSubmitted && !isSubmitSuccessful) {
    sallieText = t.error;
  }

  return (
    <div className="flex flex-col items-center mx-auto md:w-1/2">
      <Sallie text={sallieText} />

      {!isSubmitSuccessful && (
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="m-3"
        >
          <LabelledInput
            name="email"
            type="email"
            label={t.email}
            labelAs="h6"
            inputRef={register}
            errors={errors}
            required
            autoFocus
          />
          <LabelledInput
            name="name"
            label={t.name}
            labelAs="h6"
            inputRef={register}
            errors={errors}
            required
          />
          <LabelledInput
            name="ticket"
            inputAs="textarea"
            label={t.textarea_label}
            labelAs="h6"
            extraInfo={t.textarea_info}
            inputRef={register}
            errors={errors}
            required
          />

          <div className="flex justify-between md:mt-2">
            <SubmitButton
              type="button"
              onClick={history.goBack}
              disabled={isSubmitting}
            >
              {t.go_back}
            </SubmitButton>
            <SubmitButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Saving…" : t.submit}
            </SubmitButton>
          </div>
        </form>
      )}
    </div>
  );
};

export default HelpPage;
